module.exports = __webpack_public_path__ + "static/media/logo_light.16640271.png";